<template>
    <div>
        <progress-header />

        <div class="container mt-4">
            <div class="row">
                <form class="col-12" @submit.prevent="handleSubmit">
                    <div class="card shadow-sm">
                        <div class="px-4 py-3 border-bottom">
                            <h4 class="text-blue-600 font-weight-bold">
                                {{ $t('taxi.pages.options.header') }}
                            </h4>
                        </div>

                        <div class="row px-4 py-3">
                            <div class="col-12 col-lg-4" v-for="(options, type) in travelOptionsByType" :key="type">
                                <div class="text-lg text-blue-600 font-weight-bold mb-3">
                                    {{ findTravelOptionTypeLabel(type) }}
                                </div>

                                <div class="d-flex justify-content-between mb-2" v-for="option in options"
                                    :key="option.id"
                                >
                                    <div>
                                        <div class="font-weight-bold">
                                            {{ option.label }}
                                        </div>
                                    </div>

                                    <div class="d-flex align-items-center flex-nowrap">
                                        <font-awesome-icon icon="minus-circle" size="sm" class="cursor-pointer button-icon"
                                            @click="handleOptionDecrease(option)"
                                        />

                                        <div class="px-2 text-blue-600 font-weight-bold">
                                            {{ option.quantity }}
                                        </div>

                                        <font-awesome-icon icon="plus-circle" size="sm" class="cursor-pointer button-icon"
                                            @click="handleOptionIncrease(option)"
                                        />
                                    </div>
                                </div>
                            </div>

                            <div class="col-12 mt-4 mb-2">
                                <textarea class="form-control w-100" rows="5"
                                    :placeholder="$t('taxi.pages.options.comments')"
                                    v-model="comments"
                                />
                            </div>
                        </div>

                        <div class="row mt-3">
                            <div class="col-12">
                                <button type="submit" class="btn btn-primary w-100">
                                    {{ $t('next') }}
                                </button>
                            </div>
                        </div>
                    </div>
                </form>
            </div>
        </div>
    </div>
</template>

<script>
    import { mapGetters } from 'vuex';
    import { groupBy as _groupBy } from 'lodash-es';
    import ProgressHeader from './components/ProgressHeader';
    import CoachesRepository from '@repositories/CoachesRepository';

    export default {
        components: {
            ProgressHeader,
        },

        data() {
            return {
                isLoading: false,
            };
        },

        computed: {
            ...mapGetters({
                findTravelOptionTypeLabel: 'constants/findTravelOptionTypeLabel',
                travelOptions: 'coachesOrder/getTravelOptions',
            }),

            comments: {
                get() {
                    return this.$store.getters['coachesOrder/getTravelOptionComments'];
                },

                set(value) {
                    this.$store.dispatch('coachesOrder/setTravelOptionComments', value);
                },
            },

            travelOptionsByType: function () {
                return _groupBy(this.travelOptions, 'type');
            },
        },

        created() {
            let previousOptionQuantities = [];

            if (this.travelOptions) {
                this.travelOptions.forEach((option) => {
                    previousOptionQuantities[option.id] = option.quantity;
                });
            }

            CoachesRepository.getTravelOptions().then(({ data }) => {
                this.$store.dispatch(
                    'coachesOrder/setTravelOptions',
                    data.travelOptions.map((option) => {
                        if (previousOptionQuantities[option.id]) {
                            option.quantity = previousOptionQuantities[option.id];
                        }

                        return option;
                    })
                );

                this.isLoading = false;
            });
        },


        methods: {
            handleSubmit() {
                this.$store.dispatch('coachesOrder/setIsAdditionalOptionsComplete', true);
                this.$router.push({ name: 'coaches.contact' });
            },

            handleOptionDecrease(option) {
                if (option.quantity === 0) {
                    return;
                }

                this.updateQuantity(option.id, -1);
            },

            handleOptionIncrease(option) {
                this.updateQuantity(option.id, 1);
            },

            updateQuantity(optionId, value) {
                const options = JSON.parse(JSON.stringify(this.travelOptions));
                const option = options.find((option) => option.id === optionId);

                option.quantity += value;

                this.$store.dispatch('coachesOrder/setTravelOptions', options);
            },
        },
    };
</script>

<style scoped>
    @media (max-width: 992px) {
        .button-icon {
            font-size: 1.33em;
        }
    }
</style>
